import { render, staticRenderFns } from "./SubmenuBar.vue?vue&type=template&id=4ac735fc"
import script from "./SubmenuBar.vue?vue&type=script&lang=js"
export * from "./SubmenuBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports